import {DocumentType} from "../enums/documentType";
import StringHelpers from "../helpers/stringHelpers";
import { StringHelper } from '~/helpers/stringHelper';

export default {
  mixins: [StringHelpers],
  data: function() {
    return {
      DocumentType: DocumentType
    };
  },
  computed: {
    docTypeName(): string {
      switch (DocumentType[this.docType]) {
        case 'application': // fallthrough
        case 'document':
          return 'folder';
        default:
          return DocumentType[this.docType];
      }
    },
    capitalizedDocTypeName(): string {
      return this.$options.filters.capitalize(this.docTypeName);
    },
    spacedCapitalizedDocTypeName(): string {
      let str = DocumentType[this.docType]
      str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, "$1 $2");
      str = this.$options.filters.capitalize(str);
      return str;
    },
    spacedLowerCaseDocKey(): string {
      let str = DocumentType[this.docType]
      str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, "$1 $2");
      str = str.toLowerCase(); //add space between camelCase text
      return str;
    },
    docRootKey(): string {
      switch (this.docTypeName) {
        case 'dashboard':
          // dashboard routes don't follow Rails convention and aren't pluralized
          return this.docTypeName;
        default:
          const singularKey = StringHelper.toUnderscore(StringHelper.camelToSpace(this.docTypeName));
          return `${singularKey}s`;
      }
    },
  },
};